import { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import FooterText from "../../components/footerText";
import AuthSubHeader from "../../components/authSubHeader";

import useFetch from "src/hooks/useFetch";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { ScheduleRepVisitApiResponse } from "./types";
import { AuthContext } from "src/context/authContext";
import { HCPUserSubHeaderProps } from "src/types/users";


const NewRepVisit: FC = (): JSX.Element => {
  const [radioValue, setRadioValue] = useState<string>('');

  const { showToast } = useContext(ToastContext);
  const { hideLoader } = useContext(LoaderContext);
  const { userData, sub_header } = useContext(AuthContext);

  const navigate = useNavigate();




  const { loading, data: repVisitData, mutate: repVisit, error: repVisitError } =
    useFetch<ScheduleRepVisitApiResponse>(APIEndpoints.SCHEDULE_REP_VISIT, {}, {}, false)

  useEffect(() => {
    if (repVisitData || repVisitError) {
      if (repVisitData) {
        if (repVisitData.status.code === 200) {
          showToast([`Rep Visit Scheduled Succesfully`], ToastTypes.SUCCESS);
          navigate('/cases');
        }
      }
      hideLoader();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [repVisitData, repVisitError]);

  const scheduleRepVisit = () => {
    if (radioValue) {
      const requestBody = {
        reason: radioValue
      }
      repVisit(requestBody)
    } else {
      showToast(["Please Select one option"], ToastTypes.WARNING)
    }

  }

  const onClickRadioButton = (value: string) => {
    setRadioValue(value)
  }

  return (
    <div className="container-fluid auth-page overflow-auto flex-fill">
      <div className={"container container-short"}>
        <div className="row justify-content-center">
          <div className="col-12">
            <AuthSubHeader />

            <div className="card mt-4 mb-4">
              <div className="card-header bg-success-subtle">
                {/* <h3 className="text-black mb-0">
                  Schedule a Field Access Manager (FAM) with your  {sub_header
                                ? (sub_header as HCPUserSubHeaderProps)["Your Field Access Manager is:"]
                                : "FAM"}
                </h3> */}
                {/* <h3 className="text-black mb-0">
                  Schedule a Field Access Manager with your{" "}
                  {sub_header
                    ? ((sub_header as HCPUserSubHeaderProps)["Your Field Access Manager is:"]) 
                    : "FAM"}
                </h3> */}
                {/* <h3 className="text-black mb-0">
                  Schedule a Field Access Manager (FAM) with your{" "}
                  {(() => {
                    const famName =
                      sub_header &&
                      (sub_header as HCPUserSubHeaderProps)["Your Field Access Manager is:"];
                      console.log("FamName.....",famName,"   ",famName && famName.toLowerCase())
                    return famName && (famName.toLowerCase() === "demo fam" || famName === 'unassigned region')
                      ? "FAM"
                      : famName;
                  })()}
                </h3> */}
                {userData?.ref_type !== "district_manager" && <h3 className="text-black mb-0">
                  Schedule a Field Access Manager (FAM) visit with your{" "}
                  {(() => {
                    const famName =
                      sub_header &&
                      (sub_header as HCPUserSubHeaderProps)["Your Field Access Manager is:"];

                    if (!famName) return "FAM";

                    const lowerName = famName.toLowerCase();

                    // Replace Demo FAM and Unassigned Region with "FAM"
                    if (lowerName === "demo fam" || lowerName === "unassigned region") {
                      return "FAM";
                    }

                    return famName;
                  })()}
                </h3>}
              </div>

              <div className="card-body">
                <p>Fill out the form below and your rep will get in touch with you shortly</p>

                <div className="card">
                  <div className="card-header bg-success-subtle">
                    <h3 className="text-black mb-0"> I would like: </h3>
                  </div>

                  <div className="card-body">

                    <div className="form-check">
                      <input className="form-check-input" type="radio" name="requestReason"
                        id="supportOverview"
                        onClick={() => onClickRadioButton(' My QUTENZA Connect Overview/Demonstration/Support')} />
                      <label className="form-check-label" htmlFor="supportOverview">
                        My QUTENZA Connect Overview/Demonstration/Support
                      </label>
                    </div>
                    <div className="form-check">
                      <input className="form-check-input" type="radio" name="requestReason" id="getJelmyto"
                        onClick={() => onClickRadioButton('How to get QUTENZA')} />
                      <label className="form-check-label" htmlFor="getJelmyto">
                        How to get QUTENZA
                      </label>
                    </div>
                    <div className="form-check">
                      <input className="form-check-input" type="radio" name="requestReason" id="jelmytoSupport"
                        onClick={() => onClickRadioButton('QUTENZA access support')} />
                      <label className="form-check-label" htmlFor="jelmytoSupport">
                        QUTENZA access support
                      </label>
                    </div>
                    <div className="form-check">
                      <input className="form-check-input" type="radio" name="requestReason" id="reimbursementGuide"
                        onClick={() => onClickRadioButton('Reimbursement Guide questions')} />
                      <label className="form-check-label" htmlFor="reimbursementGuide">
                        Reimbursement Guide questions
                      </label>
                    </div>
                    <div className="form-check">
                      <input className="form-check-input" type="radio" name="requestReason" id="other"
                        onClick={() => onClickRadioButton('Other')} />
                      <label className="form-check-label" htmlFor="other">
                        Other
                      </label>
                    </div>
                  </div>
                </div>
                <p className="mt-2 text-dark-emphasis">
                  By providing the information requested above, I authorize Averitas to store the information I have
                  provided and may contact me from time to time by telephone, mail, or email to provide information
                  about
                  products or services that may be of interest to me. I understand that the information will be treated
                  confidentially and will be accessed only by authorized personnel or third parties under contract with
                  Averitas or its affiliates.</p>
                <button type="button" disabled={loading} className="btn btn-blue" onClick={scheduleRepVisit}>
                  Request Visit
                </button>
              </div>
            </div>

            <FooterText />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewRepVisit;
